<template>
  <div class="message_block">
    <div>
      <MessageBox
        v-for="(message, index) in messages"
        :key="index"
        :message="message"
        :talker-type="talker"
        :names="names"
      />
    </div>

    <textarea class="textarea_form" v-model="newMessage.content"/>
    <button class="orange-ellipse_button" @click="registerMessage()">投稿</button>
  </div>
</template>

<script>
  import moment from "moment";

  import MessageBox from "@/components/molecules/box/MessageBox";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import sub_collection from "@/assets/js/functions/firebase/firestore/sub_collection";

  export default {
    name: "MessageBlock",

    components: {MessageBox},

    mixins: [collection, sub_collection],

    data() {
      return {
        newMessage: {
          talker: '',
          content: '',
        },
      }
    },

    props: {
      messages: {
        type: Array,
        required: true
      },
      matchingId: {
        type: String,
        required: true
      },
      talker: {
        type: String,
        required: true
      },
      names: {
        type: Object,
        required: true
      },
    },

    methods: {
      async updateMessageList() {
        const tempMessage = {...this.newMessage};
        tempMessage.createdAt = {seconds: moment().unix()};
        this.messages.push(tempMessage);
        this.newMessage.content = '';
      },

      async registerMessage() {
        this.newMessage.talker = this.talker;
        const subCollectionDocRef = this.subCollectionDocRef(
          'matchings',
          this.matchingId,
          'messages'
        );

        await this.createSubCollectionDocument(
          subCollectionDocRef,
          null,
          this.newMessage,
        ).then(() => {
          this.showSuccessMessage('メッセージを投稿しました。');
          this.updateMessageList();
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },
    },

  }
</script>

<style lang="scss" scoped>
  .message_block {
    display: flex;
    flex-flow: column;

    > div {
      margin-top: 2rem;
      height: 30rem;
      overflow: scroll;
    }

    > .textarea_form {
      margin-top: 2rem;
      width: 100%;
    }

    > .orange-ellipse_button {
      margin: 2rem 0;
      align-self: flex-end;
    }
  }

</style>